<template>
  <div class="pad-admin-index">
    <div class="page-title">数智健康管理系统</div>
    <div class="page-tips">2023健康中国，职工先行</div>
    <div class="button-list">
      <div class="button-item" @click="goPage('/padAdmin/company')">
        <div class="icon"><img src="../../assets/images/icon_1.png" alt=""></div>
        <div class="title">樂雅健康</div>
      </div>
      <div class="button-item" @click="goPage('/padAdmin/person')">
        <div class="icon"><img src="../../assets/images/icon_2.png" alt=""></div>
        <div class="title">职工建档</div>
      </div>
      <div class="button-item" @click="goPage('/padAdmin/shop')">
        <div class="icon"><img src="../../assets/images/icon_3.png" alt=""></div>
        <div class="title">智慧优选</div>
      </div>
    </div>
  </div>
</template>

<script>
import idleDetection from '@/mixins/idleDetection';

export default {
  name: 'pad-admin-index',
  mixins: [idleDetection],
  data() {
    return {

    }
  },
  methods: {
    goPage(page) {
      if (page == '/padAdmin/shop') {
        this.$router.push({
          path: '/shop/list'
        });
        return;
      }
      this.$router.push({
        path: page
      })
    }
  }
}
</script>

<style scoped lang="scss">
.pad-admin-index {
  padding: 70px 70px 0;

  .page-title {
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 72px;
    color: #FFFFFF;
  }

  .page-tips {
    line-height: 0;
    font-weight: 300;
    margin-top: 29px;
    font-size: 30px;
    color: #FFFFFF;
    opacity: 0.6;
  }

  .button-list {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .button-item {
      padding-top: 88px;
      width: 515px;
      height: 561px;
      background: url("../../assets/images/icon_bg.png");
      border-radius: 6px 6px 20px 20px;
      opacity: 0.9;
      background-size: 100%;

      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      .icon {
        width: 366px;
        height: 323px;
        img {width: 100%;height: 100%;}

      }
      .title {
        margin-top: 56px;
        font-weight: 600;
        font-size: 40px;
        color: #FFFFFF;
        line-height: 36px;
      }
    }
  }




}
</style>
